import React from 'react';
import { Input as AntInput, InputProps as AntInputProps, InputRef } from 'antd';
import styles from './InputPassword.module.scss';

interface InputPasswordProps extends AntInputProps {
  className?: string;
  visibilityToggle?: boolean;
  iconRender?: (visible: boolean) => React.ReactNode;
}

export const InputPassword = React.forwardRef<InputRef, InputPasswordProps>(
  ({ className, children, ...props }, ref) => (
    <AntInput.Password
      ref={ref}
      className={[styles.inputPassword, className].filter(Boolean).join(' ')}
      {...props}
    >
      {children}
    </AntInput.Password>
  )
);
